import { getDocType } from '../reactives/docTypes.reactive';

// Not in doctype.util to avoid dependency cycle.
export const doctypeHasAutomation = (doctypeId?: string) => {
  const data = getDocType(doctypeId);
  return !!data?.linearEntity && !!data.linearTeam;
};
